import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "argument-count" }
const _hoisted_2 = { class: "count-summary mb-6" }
const _hoisted_3 = { class: "summary-cards" }
const _hoisted_4 = { class: "text-h4" }
const _hoisted_5 = { class: "text-h4" }
const _hoisted_6 = { class: "text-h4" }
const _hoisted_7 = { class: "pie-chart-container" }
const _hoisted_8 = { class: "pie-chart-wrapper" }
const _hoisted_9 = { class: "pie-chart-legend" }
const _hoisted_10 = { class: "legend-label" }
const _hoisted_11 = { class: "legend-value" }
const _hoisted_12 = ["width", "height"]
const _hoisted_13 = {
  key: 1,
  class: "separated-charts-container"
}
const _hoisted_14 = { class: "alternative-title" }
const _hoisted_15 = { class: "alternative-summary" }
const _hoisted_16 = { class: "summary-badge primary" }
const _hoisted_17 = { class: "badge-value" }
const _hoisted_18 = { class: "summary-badge success" }
const _hoisted_19 = { class: "badge-value" }
const _hoisted_20 = { class: "summary-badge error" }
const _hoisted_21 = { class: "badge-value" }
const _hoisted_22 = { class: "pie-chart-wrapper" }
const _hoisted_23 = { class: "pie-chart-legend" }
const _hoisted_24 = { class: "legend-label" }
const _hoisted_25 = { class: "legend-value" }
const _hoisted_26 = ["width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectedAlternative !== 'all-separated')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_card, {
                variant: "tonal",
                color: "primary",
                class: "summary-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.totalCount), 1),
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-caption" }, "Total Arguments", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                variant: "tonal",
                color: "success",
                class: "summary-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.favorableCount), 1),
                      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-caption" }, "Favorable", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                variant: "tonal",
                color: "error",
                class: "summary-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.unfavorableCount), 1),
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-caption" }, "Unfavorable", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legendItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.label,
                    class: "legend-item"
                  }, [
                    _createElementVNode("span", {
                      class: "legend-swatch",
                      style: _normalizeStyle({ backgroundColor: item.color })
                    }, null, 4),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.count), 1)
                  ]))
                }), 128))
              ]),
              (_openBlock(), _createElementBlock("svg", {
                ref: "chartRef",
                width: _ctx.width,
                height: _ctx.height
              }, null, 8, _hoisted_12))
            ])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.separatedChartsData, (altData, altId) => {
            return (_openBlock(), _createElementBlock("div", {
              key: altId,
              class: "alternative-chart-card"
            }, [
              _createElementVNode("h3", _hoisted_14, _toDisplayString(altData.name), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(altData.totalCount), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "badge-label" }, "Total", -1))
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(altData.favorableCount), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "badge-label" }, "Favorable", -1))
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(altData.unfavorableCount), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "badge-label" }, "Unfavorable", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(altData.legendItems, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.label,
                      class: "legend-item"
                    }, [
                      _createElementVNode("span", {
                        class: "legend-swatch",
                        style: _normalizeStyle({ backgroundColor: item.color })
                      }, null, 4),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(item.label), 1),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(item.count), 1)
                    ]))
                  }), 128))
                ]),
                (_openBlock(), _createElementBlock("svg", {
                  ref_for: true,
                  ref: (el) => _ctx.setSvgRef(altId, el),
                  width: _ctx.width,
                  height: _ctx.height,
                  class: "chart-svg"
                }, null, 8, _hoisted_26))
              ])
            ]))
          }), 128))
        ]))
  ]))
}